import React from 'react';
import './Feedback.css';
import { trackFeedback } from '../utils/analytics';

const Feedback: React.FC = () => {
  return (
    <div className="feedback-page">
      <div className="feedback-header">
        <div className="container">
          <div className="feedback-logo">
            <img src="/choretap-logo.png" alt="ChoreTap Logo" />
          </div>
          <h1>Send Us Your Feedback</h1>
          <p className="feedback-subtitle">
            We'd love to hear from you! Your feedback helps us make ChoreTap better for families everywhere.
          </p>
        </div>
      </div>

      <div className="feedback-content">
        <div className="container">
          <div className="feedback-options">
            <div className="feedback-option">
              <div className="feedback-icon">📧</div>
              <h2>Email Us</h2>
              <p>Have a question or need support? Send us an email and we'll get back to you as soon as possible.</p>
              <a
                href="mailto:support@choretap.app"
                className="btn btn-primary btn-large"
                onClick={() => {
                  trackFeedback('email');
                }}
              >
                Email support@choretap.app
              </a>
            </div>

            <div className="feedback-option">
              <div className="feedback-icon">💡</div>
              <h2>Share Your Ideas</h2>
              <p>Got a feature request or suggestion? We want to hear it! Visit our feedback portal to share your ideas and vote on what matters most to you.</p>
              <a
                href="https://choretap.userjot.com/?cursor=1&order=top&limit=10"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary btn-large"
                onClick={() => {
                  trackFeedback('portal');
                }}
              >
                Visit Feedback Portal
              </a>
            </div>
          </div>

          <div className="feedback-info">
            <h3>What We're Looking For</h3>
            <div className="feedback-info-grid">
              <div className="info-item">
                <span className="info-emoji">🐛</span>
                <h4>Bug Reports</h4>
                <p>Found something not working right? Let us know!</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">✨</span>
                <h4>Feature Ideas</h4>
                <p>Have an idea to make ChoreTap even better?</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">💬</span>
                <h4>General Feedback</h4>
                <p>Share your thoughts on your experience with ChoreTap.</p>
              </div>
              <div className="info-item">
                <span className="info-emoji">🎉</span>
                <h4>Success Stories</h4>
                <p>Tell us how ChoreTap has helped your family!</p>
              </div>
            </div>
          </div>

          <div className="feedback-faq">
            <h3>Quick Questions?</h3>
            <div className="faq-list">
              <div className="faq-item">
                <h4>How quickly will I get a response?</h4>
                <p>We aim to respond to all emails within 24-48 hours during business days.</p>
              </div>
              <div className="faq-item">
                <h4>Can I track my feature request?</h4>
                <p>Yes! When you submit feedback through our portal, you can track its status and see what other users are requesting.</p>
              </div>
              <div className="faq-item">
                <h4>Is my feedback anonymous?</h4>
                <p>You can choose to submit feedback anonymously through our portal, or include your contact info if you'd like us to follow up.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feedback-footer">
        <div className="container">
          <p>Thank you for helping us build a better ChoreTap! 💙</p>
          <a href="/" className="back-home">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default Feedback;

